import axios from "axios";

export const api = axios.create ({
    baseURL: process.env.REACT_APP_API_LINK,
    headers: {
        "Content-Type": "application/json",
        "Authorization" : localStorage.getItem("AuthToken")
    },
});
